import { EntityType } from 'api'
import { Locale, Translation } from 'locale'
import { noop } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { ClearingHouseDialogComponent } from './ClearingHouseDialogComponent'

interface ClearingHouseViewProps {
  entityId: string
  onClose?: () => void
}
export const ClearingHouseViewDialog: React.FC<ClearingHouseViewProps> = ({ entityId, onClose = noop }) => {
  const getClearingHouse = useSelector(createEntityGetterSelector(EntityType.CLEARING_HOUSE))
  const clearingHouse = getClearingHouse(entityId)
  if (!clearingHouse) {
    return null
  }

  return (
    <ClearingHouseDialogComponent
      title={Locale.translate(Translation.TC_VIEW_CLEARING_HOUSE_DETAILS)}
      clearingHouse={clearingHouse}
      hasValidationIssues={false}
      onClose={onClose}
      onSave={noop}
      onUpdate={noop}
      readOnly={true}
    />
  )
}
